document.addEventListener('DOMContentLoaded', function() {
  const accordionItems = document.querySelectorAll('.accordion-item');
  const openIconSVG = `
    <svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.86985 1.87631L8.51363 1.55437L8.15743 1.87631L1.89422 7.53681L1.51713 7.19598L8.28489 1.07944C8.28495 1.07939 8.28483 1.0795 8.28489 1.07944C8.33729 1.03224 8.4189 0.99764 8.51363 0.99764C8.60837 0.99764 8.68981 1.03208 8.7422 1.07928C8.74226 1.07934 8.74213 1.07923 8.7422 1.07928L15.5159 7.20116L15.1387 7.54199L8.86985 1.87631Z" fill="black"/>
      <path d="M8.28489 1.07944L1.51713 7.19598L1.89422 7.53681L8.15743 1.87631L8.51363 1.55437L8.86985 1.87631L15.1387 7.54199L15.5159 7.20116L8.7422 1.07928M8.28489 1.07944C8.28495 1.07939 8.28483 1.0795 8.28489 1.07944ZM8.28489 1.07944C8.33729 1.03224 8.4189 0.99764 8.51363 0.99764C8.60837 0.99764 8.68981 1.03208 8.7422 1.07928M8.7422 1.07928C8.74226 1.07934 8.74213 1.07923 8.7422 1.07928Z" stroke="#212121" stroke-width="1.0625"/>
    </svg>`;
  const closeIconSVG = `
    <svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.28489 7.53681L8.7422 7.19598C8.68981 7.14878 8.60837 7.11418 8.51363 7.11418C8.4189 7.11418 8.33729 7.14878 8.28489 7.19598L1.51713 1.07944L1.89422 0.738602L8.15743 6.3991L8.51363 6.72105L8.86985 6.3991L15.1387 0.73343L15.5159 1.07426L8.7422 7.19614L8.74226 7.19609C8.68981 7.24329 8.60837 7.27789 8.51363 7.27789C8.4189 7.27789 8.33729 7.24329 8.28489 7.19614L8.28489 7.53681Z" fill="black"/>
      <path d="M8.86985 7.19598L8.51363 7.51793L8.15743 7.19598L1.89422 1.53548L1.51713 1.87631L8.28489 8.00902C8.28495 8.00907 8.28483 8.00896 8.28489 8.00902C8.33729 8.05622 8.4189 8.09082 8.51363 8.09082C8.60837 8.09082 8.68981 8.05638 8.7422 8.00918C8.74226 8.00912 8.74213 8.00923 8.7422 8.00918L15.5159 1.8873L15.1387 1.54647L8.86985 7.19598Z" fill="black"/>
      <path d="M8.28489 8.00902L1.51713 1.87631L1.89422 1.53548L8.15743 7.19598L8.51363 7.51793L8.86985 7.19598L15.1387 1.5303L15.5159 1.87113L8.7422 8.00912M8.28489 8.00902C8.28483 8.00896 8.28495 8.00907 8.28489 8.00902ZM8.28489 8.00902C8.33729 8.05622 8.4189 8.09082 8.51363 8.09082C8.60837 8.09082 8.68981 8.05638 8.7422 8.00918M8.7422 8.00918C8.74213 8.00923 8.74226 8.00912 8.7422 8.00918Z" stroke="#212121" stroke-width="1.0625"/>
    </svg>`;

  accordionItems.forEach(item => {
    const title = item.querySelector('.accordion-title');
    const icon = item.querySelector('.accordion-icon');

    title.addEventListener('click', () => {
      // Toggle active class
      item.classList.toggle('active');

      // Toggle icon
      if (item.classList.contains('active')) {
        icon.innerHTML = openIconSVG;
      } else {
        icon.innerHTML = closeIconSVG;
      }

      // Close other items
      accordionItems.forEach(otherItem => {
        if (otherItem !== item) {
          otherItem.classList.remove('active');
          otherItem.querySelector('.accordion-icon').innerHTML = closeIconSVG;
        }
      });
    });
  });
});
